import type { TraceUpload } from "@common/api/trace-attachments"
import { createContext, useContext } from "react"

export const TraceUploadContext = createContext<TraceUpload | null>(null)

export function useTraceUploadContext() {
  return useContext(TraceUploadContext)
}
